import jQuery from "jquery";
(function (far, $) {
  far.buttonAriaState = {};

  //#region Public functions ====================================================

  far.buttonAriaState.initialize = function () {
    toggleAriaState();
  };

  //#endregion

  //#region Private functions ===================================================

  function toggleAriaState() {
    $("button[aria-pressed]").off("click").on("click", handleButtonPress);
  }

  function handleButtonPress(e) {
    e.preventDefault();

    var $this = $(this);
    var context = $this.data("context");
    var newState = $this.attr("aria-pressed") === "false" ? true : false;

    if (typeof context === "string" && context.length > 0) {
      closeAllOfContext(context);
    }

    $this.attr("aria-pressed", newState);
  }

  function closeAllOfContext(context) {
    $('button[data-context="' + context + '"').attr("aria-pressed", false);
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
